import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

import { useFrpSession } from '../features/session/frp-session-context';
import { setAnalyticsUser, trackEvent, trackPageView } from '../lib/analytics';

export function AnalyticsListener() {
  const location = useLocation();
  const navigationType = useNavigationType();
  const session = useFrpSession();
  const previousAuthRef = useRef<boolean | null>(null);

  useEffect(() => {
    const route = `${location.pathname}${location.search}${location.hash}`;
    trackPageView(route);
    trackEvent('route_changed', {
      route,
      navigation_type: navigationType,
    });
  }, [location.pathname, location.search, location.hash, navigationType]);

  useEffect(() => {
    if (session.status === 'loading') {
      return;
    }

    const authenticated = session.status === 'authenticated';
    const changed = previousAuthRef.current !== authenticated;

    if (changed) {
      trackEvent('auth_state_change', {
        authenticated,
        linked_org: session.linkedOrg?.id || null,
      });
    }

    if (authenticated && session.user?.uid) {
      setAnalyticsUser(session.user.uid);
    } else {
      setAnalyticsUser(null);
    }

    previousAuthRef.current = authenticated;
  }, [session.status, session.user?.uid, session.linkedOrg?.id]);

  return null;
}
